/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Dialog, Button, Image } from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import closeIcon from "@icons/ic-close-white.svg";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  ProductContainer,
  GridSubItem,
} from "./AddEditDashboardWidget.styled";

const AddEditDashboardWidget = (props) => {
  const { t, selectedWidget, onClose, setIsRefreshList, adminId } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [widgetIds, setWidgetIds] = useState([]);
  const [widgetList, setWidgetList] = useState([]);
  const [updateWidgetAPIError, setUpdateWidgetAPIError] = useState("");
  const [isWidgetUpdating, setIsWidgetUpdating] = useState(false);

  const fetchAllWidgetList = () => {
    setIsLoading(true);
    axios
      .get(`/dashboard/widgets`)
      .then((response) => {
        setIsLoading(false);
        setWidgetList(response.data.dashboardWidgets);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchAllWidgetList();
  }, []);

  useEffect(() => {
    if (selectedWidget.length > 0) {
      const ids = [];
      selectedWidget.map((data) => {
        ids.push(data.id);
      });
      setWidgetIds(ids);
    }
  }, [selectedWidget]);

  const updateWidgetArray = (listId) => {
    const widgetExistingIds = widgetIds;
    if (widgetExistingIds.indexOf(listId) === -1) {
      widgetExistingIds.push(listId);
    } else {
      const index = widgetExistingIds.indexOf(listId);
      widgetExistingIds.splice(index, 1);
    }
    setWidgetIds([...widgetExistingIds]);
  };

  const getFormData = () => {
    const widgetArray = [];

    if (widgetIds.length > 0) {
      widgetIds.map((id) => {
        const widgetInfo = widgetList.find((widget) => widget.id === id);
        widgetArray.push({
          id: widgetInfo.id,
          name: widgetInfo.name,
          description: widgetInfo.description,
        });
      });
    }
    return widgetArray;
  };

  const onSubmit = () => {
    setIsWidgetUpdating(true);
    setUpdateWidgetAPIError("");
    axios
      .post(`/dashboard/${adminId}/widgets`, getFormData())
      .then(() => {
        setIsWidgetUpdating(false);
        setIsRefreshList(true);
        onClose();
      })
      .catch((error) => {
        setIsWidgetUpdating(false);
        setUpdateWidgetAPIError(error.response?.data?.message ?? "");
      });
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>{t("WIDGET_TITLE_CONFIGURATION_PANEL")}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close meeting report popup"
              styles={{ width: "auto", cursor: "pointer" }}
            />
          </Button>
        </HeaderWrapper>
        {isLoading && (
          <div className="suggestions-list-loading">
            <PulseLoader color="#1bace4" size={15} />
          </div>
        )}

        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow column="1fr" gap="0rem">
                    {widgetList.length > 0 &&
                      widgetList.map((list) => {
                        return (
                          <ProductContainer
                            key={"dashboard-widget-" + list?.id}
                          >
                            <GridRow
                              column="1fr auto"
                              marginBottom="5px"
                              borderBottom="1px solid #cccccc"
                            >
                              <GridSubItem
                                fontWeight="700"
                                fontSize="16px"
                                padding="0px"
                              >
                                {t(list.name)}
                              </GridSubItem>
                              <GridSubItem>
                                <Image
                                  src={
                                    widgetIds.indexOf(list.id) !== -1
                                      ? enableIcon
                                      : disableIcon
                                  }
                                  onClick={() => updateWidgetArray(list.id)}
                                  alt="enable disable widget"
                                  styles={{ width: "auto", cursor: "pointer" }}
                                />
                              </GridSubItem>
                            </GridRow>
                            <GridRow column="1fr auto" gap="0rem">
                              <GridSubItem color="#474747" fontStyle="italic">
                                {t(list.description)}
                              </GridSubItem>
                            </GridRow>
                          </ProductContainer>
                        );
                      })}
                  </GridRow>
                </div>
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>

        <ButtonWrapper>
          {updateWidgetAPIError && <div>{updateWidgetAPIError}</div>}
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CANCEL")}
          </Button>

          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isWidgetUpdating && <ClipLoader size={15} color="#fff" />}
              {!isWidgetUpdating && t("VALIDATE")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditDashboardWidget.propTypes = {
  t: PropTypes.func.isRequired,
  selectedWidget: PropTypes.number,
};

AddEditDashboardWidget.defaultProps = {
  selectedWidget: {},
};
export default withTranslation()(AddEditDashboardWidget);
